import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const contactAPI = {
  submit: async (data) => {
    const response = await api.post('/contact', data);
    return response.data;
  },
  getAll: async () => {
    const response = await api.get('/contacts');
    return response.data;
  }
};

export const newsletterAPI = {
  subscribe: async (email) => {
    const response = await api.post('/newsletter', { email });
    return response.data;
  }
};

export const projectAPI = {
  trackView: async (id) => {
    const response = await api.post(`/projects/${id}/view`);
    return response.data;
  },
  getAll: async (page = 1, limit = 6) => {
    const response = await api.get(`/projects?page=${page}&limit=${limit}`);
    return response.data;
  },
};

export const statsAPI = {
  get: async () => {
    const response = await api.get('/stats');
    return response.data;
  }
};

export const researchAPI = {
  get: async () => {
    const response = await api.get('/research');
    return response.data;
  }
};

export const authAPI = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  }
};

export default api;
